module.exports = __webpack_public_path__ + "static/media/2_55-_DSC8958-3.db8a47e9.webp";